'use strict';

(function () {
  'use strict';

  angular.module('msPublicActivities').config(publicConfig);

  publicConfig.$inject = ['$stateProvider', 'errorRouterProvider', 'activityRouterProvider', 'publicActivityRouterProvider'];

  function publicConfig($stateProvider, errorRouterProvider, activityRouterProvider, publicActivityRouterProvider) {

    registerRoutes();

    function registerRoutes() {
      _registerBaseRoutes();
      _registerErrorRoutes();
      _registerActivityRoutes();
    }

    function _registerErrorRoutes() {
      var errorRoutes = errorRouterProvider.buildRoutes('public.content');
      //wire the routes
      for (var index in errorRoutes) {
        if (errorRoutes.hasOwnProperty(index)) {
          var route = errorRoutes[index];
          if (route.hasOwnProperty('name')) {
            _registerErrorRoute(route);
          }
        }
      }
    }

    function _registerErrorRoute(route) {
      if (route.name === 'public.content.error') {
        //HACK - drop the / from the error URLs for some dumb reason
        route.url = route.url.substring(1, route.url.length);
        route.templateUrl = 'vnext/pages/error/error.html';
      }
      $stateProvider.state(route.name, route);
    }

    function _registerBaseRoutes() {
      $stateProvider.state('public', {
        url: '/?o&g&pc&ref&signupurl&t&loginUrl',
        abstract: true,
        data: {
          noAuth: true,
          pageTitle: 'pageTitles.vnext'
        },
        params: {
          o: {
            value: null //organization
          },
          g: {
            value: null //group
          },
          pc: {
            value: null //access code
          },
          ref: {
            value: null //referral token
          },
          signupurl: {
            value: null
          },
          t: {
            value: null //token for existing user
          }
        },
        views: {
          'main': {
            controller: 'PublicContentCtrl',
            controllerAs: 'publicVm',
            templateUrl: 'publicActivities/pages/public.html'
          }
        }
      }).state('public.content', {
        url: '',
        abstract: true,
        data: {
          noAuth: true
        },
        views: {
          'content': {
            template: '<div ui-view></div>'
          }
        }
      });
    }

    function _registerActivityRoutes() {
      var originalRoutes = activityRouterProvider.buildRoutes('public.content', '.homepage');
      //augment the routes with public facing replacement logic
      var activityRoutes = publicActivityRouterProvider.augmentRoutes(originalRoutes);
      //wire the routes
      for (var index in activityRoutes) {
        if (activityRoutes.hasOwnProperty(index)) {
          var route = activityRoutes[index];
          if (route.hasOwnProperty('name')) {
            $stateProvider.state(route.name, route);
          }
        }
      }
    }
  }
})();